    <template>
        <v-container fluid class="pa-4">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <div>
                        <span class="title">{{ $t('title.MaintenanceDetail') }}</span>

                        <v-divider class="mb-1" />

                        <div class="title-INVESTMENT">
                            {{ maintenance?.Name }}
                        </div>

                        <div style="font-size:14px; font-weight: 400;" v-if="maintenance">
                            <div>
                                <v-progress-linear :model-value="usagePercent" :color="usageColor" height="20" rounded>
                                    <strong class="ml-2">
                                        {{ usagePercent }}%
                                    </strong>
                                </v-progress-linear>

                                <div class="mt-3">
                                    {{ $t('general.MaintenanceDetailUtroseno') }} / {{
                                        $t('general.MaintenanceDetailVrUgovora') }}: <strong>
                                        {{ formatMoney(maintenance.Utroseno) }}
                                        /
                                        {{ formatMoney(maintenance.Value) }}</strong>
                                </div>
                            </div>

                            {{ $t('general.MaintenanceDetailPotpisano') }}<strong>{{
                                formatDate(maintenance.Date) }} </strong><br>
                            {{ $t('general.MaintenanceDetailIstice') }} <strong>{{
                                formatDate(maintenance.Expired)
                            }} </strong>
                        </div>
                    </div>
                    <div>
                        <v-tooltip location="bottom" content-class="custom-tooltip">
                            <template #activator="{ props }">
                                <span v-bind="props">
                                    <v-btn size="small" variant="outlined" color="primary" class="action-btn mr-2"
                                        icon="mdi-plus" @click="openAddIssue"
                                        :disabled="isExpired || maintenance?.Preostalo <= 0" />
                                </span>
                            </template>
                            {{ maintenance?.Preostalo <= 0 ? $t('general.nemaRaspolozivih') :
                                $t('general.addTrosak') }} </v-tooltip>

                                <v-tooltip location="bottom" content-class="custom-tooltip">
                                    <template #activator="{ props }">
                                        <v-btn v-bind="props" size="small" variant="outlined" color="secondary"
                                            class="action-btn" icon="mdi-arrow-left" @click="goBack" />
                                    </template>
                                    {{ $t('general.back') }}
                                </v-tooltip>
                    </div>
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-data-table :headers="headers" :items="issues" :loading="loadingIssues"
                        :loading-text="$t('general.loading')" class="min-width-table custom-header"
                        :items-per-page="15">

                        <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                            <tr>
                                <th v-for="column in columns" :key="column.value"
                                    @click="() => column.sortable && toggleSort(column)" :style="{
                                        cursor: column.sortable ? 'pointer' : 'default',
                                        width: column.width,
                                        maxWidth: column.width,
                                        textAlign:
                                            column.align === 'center'
                                                ? 'center'
                                                : column.align === 'end'
                                                    ? 'right'
                                                    : column.value === 'actions'
                                                        ? 'right'
                                                        : 'left'
                                    }" class="sortable-header">
                                    <div class="d-flex align-center w-100" :class="column.value === 'actions' ? 'justify-end' :
                                        ['document'].includes(column.value) ? 'justify-center' :
                                            column.align === 'end' ? 'justify-end' :
                                                'justify-space-between'
                                        ">
                                        <strong>{{ column.text }}</strong>
                                        <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                            :class="{ active: isSorted(column) }">
                                            {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                                        </v-icon>
                                    </div>
                                </th>
                            </tr>
                        </template>

                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.Description }}</td>
                                <td style="text-align: right;">{{ formatMoney(item.Value) }}</td>
                                <td>{{ item.Contractor || '-' }}</td>
                                <td style="text-align: center;">{{ formatDate(item.Date) }}</td>

                                <td class="text-center">
                                    <div style="display: flex; align-items: center; justify-content: space-between;">
                                        <v-tooltip location="bottom" content-class="custom-tooltip">
                                            <template #activator="{ props }">
                                                <v-btn v-bind="props" size="small" variant="outlined" color="teal"
                                                    class="action-btn" :disabled="!item.FileName"
                                                    @click="previewIssueDoc(item.FileName)" style="margin-right: 5px;">
                                                    <v-icon size="16">mdi-eye</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('general.pregledDokumenta') }}
                                        </v-tooltip>

                                        <v-tooltip location="bottom" content-class="custom-tooltip">
                                            <template #activator="{ props }">
                                                <v-btn v-bind="props" size="x-small" variant="outlined" color="primary"
                                                    class="mr-2 action-btn-small" @click="openChangeIssueDoc(item)">
                                                    <v-icon size="14" color="primary">mdi-pencil</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('general.editDokument') }}
                                        </v-tooltip>

                                        <v-tooltip location="bottom" content-class="custom-tooltip">
                                            <template #activator="{ props }">
                                                <v-btn v-bind="props" size="x-small" variant="text" color="red"
                                                    class="mr-2 action-btn-small" @click="openDeleteIssueDoc(item)"
                                                    :disabled="!item.FileName">
                                                    <v-icon size="14">mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('general.delete') }}
                                        </v-tooltip>
                                    </div>
                                </td>

                                <td class="actions-cell">
                                    <div class="d-flex align-center justify-end action-buttons">
                                        <v-tooltip location="bottom" content-class="custom-tooltip">
                                            <template #activator="{ props }">
                                                <v-btn v-bind="props" size="small" variant="outlined" color="primary"
                                                    class="mr-2 action-btn" @click="openEditIssue(item)">
                                                    <v-icon size="16">mdi-pencil</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('general.uredi') }}
                                        </v-tooltip>

                                        <v-tooltip location="bottom" content-class="custom-tooltip">
                                            <template #activator="{ props }">
                                                <v-btn v-bind="props" size="small" variant="outlined" color="red"
                                                    class="action-btn" @click="openDeleteDialog(item)">
                                                    <v-icon size="16">mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('general.delete') }}
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <!-- FOOTER -->
                        <template v-slot:[`body.append`]>
                            <tr class="total-row">
                                <td class="font-weight-bold">{{ $t('general.MaintenanceDetailTotal') }}</td>
                                <td class="font-weight-bold" style="text-align: right !important;">
                                    {{ formatMoney(maintenance?.Utroseno) }}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr class="tfoot-remaining">
                                <td><strong>{{ $t('general.MaintenanceDetailRemaining') }}</strong></td>
                                <td style="text-align: right !important;">
                                    <strong>{{ formatMoney(maintenance?.Preostalo) }}</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>

                    </v-data-table>
                </v-card-text>
            </v-card>

            <!-- Dijalog za dodavanje / Uređivanje kvara -->
            <BaseModal v-model="dialog"
                :title="isEditMode ? this.$t('modalni.maintenanceDetail.urediTrosak') : this.$t('modalni.maintenanceDetail.dodajTrosak')">
                <v-form ref="maintenanceDetailForm" v-model="isFormValid">
                    <v-textarea v-model="formIssue.description" :label="$t('modalni.maintenanceDetail.opisTroska')" auto-grow
                        :rules="[rules.required]" required class="my-text" />

                    <v-text-field v-model="formIssue.value" :label="$t('modalni.maintenanceDetail.vrijednost')" v-money
                        :rules="[
                            rules.required,
                            v => !!parseMoney(v) || ': ' + this.$t('modalni.maintenanceDetail.porukaBroj'),
                            rules.notOverRemaining
                        ]" class="my-text" />

                    <div class="d-flex ga-3">
                        <v-text-field v-model="formIssue.date" type="date"
                            :label="$t('modalni.maintenanceDetail.datum')" :rules="[rules.required]" clearable
                            clear-icon="mdi-close" class="my-text" style="flex: 1;" />

                        <v-text-field v-model="formIssue.contractor" :label="$t('modalni.maintenanceDetail.izvodjac')"
                            clearable class="my-text" style="flex: 1;" />
                    </div>

                    <v-file-input v-model="formIssue.fileName" :label="$t('table.maintenance.podugovor')"
                        prepend-icon="mdi-paperclip" accept=".pdf,image/*" class="my-text" />
                </v-form>
                <!-- FOOTER -->
                <template #footer>
                    <div class="d-flex justify-end ga-2">

                        <!-- OTKAŽI -->
                        <v-btn variant="outlined" @click="closeDialog">
                            <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
                        </v-btn>

                        <!-- SAČUVAJ -->
                        <v-btn color="primary" variant="flat" @click="submitIssue">
                            <span style="font-size:14px; font-weight: 600;">{{ $t('general.save') }}</span>
                        </v-btn>
                    </div>
                </template>
            </BaseModal>


            <!--  Dijalog za potvrdu brisanja kvara -->
            <BaseModal v-model="deleteDialog" :title="this.$t('modalni.maintenanceDetail.brisiTrosak')">
                <p>{{ $t('modalni.maintenanceDetail.brisanjeTroskaPoruka') }} <strong>{{ deleteIssueDescription }}</strong>?
                </p>

                <template #footer>
                    <div class="d-flex justify-end ga-2">
                        <!-- OTKAŽI -->
                        <v-btn variant="outlined" @click="deleteDialog = false">
                            <span style="font-size:14px; font-weight: 600;">{{ this.$t('general.cancel') }}</span>
                        </v-btn>

                        <!-- OBRIŠI -->
                        <v-btn color="danger" variant="flat" @click="confirmDelete">
                            <span style="font-size:14px; font-weight: 600; color: #FFF;">{{
                                this.$t('general.deleteButton') }}</span>
                        </v-btn>
                    </div>
                </template>
            </BaseModal>

            <!-- PREGLED DOKUMENTA ULAGANJA -->
            <BaseModal v-model="issueDocPreview" size="xl" height="90vh" :title="issueDocFileName"
                modalClass="report-modal" :hideFooter="true"
                @update:modelValue="val => { if (!val) closeIssueDocPreview() }">
                <template #header-actions>
                    <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" icon variant="plain" @click="downloadIssueDoc">
                                <v-icon size="18" style="padding-left: 10px;">mdi-download</v-icon>
                            </v-btn>
                        </template>
                    </v-tooltip>
                    <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.print')">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" icon variant="plain" @click="printIssueDoc">
                                <v-icon size="18">mdi-printer</v-icon>
                            </v-btn>
                        </template>
                    </v-tooltip>
                </template>
                <iframe ref="issueDocFrame" :src="issueDocUrl" style="width:100%; height:100%; border:none;" />
            </BaseModal>

            <!-- PROMJENA DOKUMENTA ULAGANJA -->
            <BaseModal v-model="changeIssueDocDialog" :title="this.$t('modalni.maintenance.changeDoc')">
                <v-file-input v-model="changeIssueDocFile" :label="$t('modalni.maintenance.dokument')"
                    prepend-icon="mdi-paperclip" accept=".pdf,image/*" class="my-text" />

                <template #footer>
                    <div class="d-flex justify-end ga-2">
                        <v-btn variant="outlined" @click="changeIssueDocDialog = false">
                            <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                        </v-btn>
                        <v-btn color="primary" @click="confirmChangeIssueDoc">
                            <span style="font-size:14px; font-weight:600;">{{ $t('general.potvrdi') }}</span>
                        </v-btn>
                    </div>
                </template>
            </BaseModal>

            <!-- BRISANJE DOKUMENTA ULAGANJA -->
            <BaseModal v-model="deleteIssueDocDialog" :title="$t('general.deleteDoc')">
                <p>{{ $t('modalni.popis.potvrdaBrisanjaDokumenta') }} <strong>{{ deleteIssueDocItem?.FileName
                        }}</strong>?</p>
                <template #footer>
                    <div class="d-flex justify-end ga-2">
                        <v-btn variant="outlined" @click="deleteIssueDocDialog = false">
                            <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                        </v-btn>
                        <v-btn color="danger" variant="flat" @click="confirmDeleteIssueDoc">
                            <span style="font-size:14px; font-weight:600; color:#FFF">{{ $t('general.deleteButton')
                                }}</span>
                        </v-btn>
                    </div>
                </template>
            </BaseModal>
        </v-container>

    </template>


    <script>
    import BaseModal from "@/components/dialogs/BaseModal.vue";
    import { format } from "date-fns";

    export default {
        name: 'MaintenanceDetail',
        props: { id: { type: String, required: true } },

        data() {

            return {
                changeIssueDocDialog: false,
                changeIssueDocItem: null,
                changeIssueDocFile: null,
                deleteIssueDocDialog: false,
                deleteIssueDocItem: null,
                issueDocPreview: false,
                issueDocUrl: null,
                issueDocFileName: null,
                issueDocBlob: null,
                uploadDocDialog: false,
                uploadDocItem: null,
                uploadDocForm: {
                    name: '',
                    file: null
                },
                dialog: false,
                isEditMode: false,

                deleteDialog: false,
                deleteIssueId: null,
                deleteIssueDescription: '',
                rules: {
                    required: v => (v !== null && v !== undefined && v !== '') || this.$t('systemMessage.m1'),
                    notOverRemaining: v => {
                        const value = this.parseMoney(v)
                        if (value === null) return true
                        if (!this.maintenance) return true

                        return value <= Number(this.maintenance.Preostalo)
                            || `${this.$t('modalni.maintenanceDetail.limit')}${this.formatMoney(this.maintenance.Preostalo)}`
                    }

                },

                maintenance: null,
                issues: [],
                isFormValid: false,
                loading: false,
                loadingIssues: false,

                dialogAdd: false,
                formIssue: {
                    id: null,
                    description: '',
                    value: '',
                    contractor: '',
                    date: '',
                    fileName: null,
                    docName: ''
                },

                headers: [
                    { text: this.$t('table.investment.opis'), value: "description", sortable: true, width: 'calc(52% - 100px)' },
                    { text: this.$t('table.investment.vrijednost'), value: "value", align: "end", sortable: true, width: "10%" },
                    { text: this.$t('table.investment.izvodjac'), value: "contractor", sortable: true, width: "20%" },
                    { text: this.$t('table.investment.datumTroska'), value: "date", align: "center", sortable: true, width: "10%" },
                    { text: this.$t('table.maintenance.podugovor'), value: "document", align: "center", sortable: false, width: "8%" },
                    { text: this.$t('general.optionsUPPER'), value: "actions", align: "end", sortable: false, width: "100px" }
                ],
            }
        },

        computed: {
            usagePercent() {
                if (!this.maintenance) return 0

                const total = Number(this.maintenance.Value)
                const spent = Number(this.maintenance.Utroseno)

                if (!total || total <= 0) return 0

                return Math.min(100, ((spent / total) * 100).toFixed(2))
            },

            usageColor() {
                if (this.usagePercent >= 90) return 'red'
                if (this.usagePercent >= 70) return 'orange'
                return 'green'
            },
            canSaveIssue() {
                if (!this.maintenance) return false

                const value = this.parseMoney(this.formIssue.value)
                const remaining = Number(this.maintenance.Preostalo)

                if (value === null || isNaN(value)) return false
                if (value <= 0) return false

                return value <= remaining
            },
            isExpired() {
                return Number(this.maintenance?.StatusId) === 3
            },
        },
        components: {
            BaseModal,
        },
        mounted() {
            this.fetchMaintenance()
            this.fetchIssues()
        },

        methods: {
            generateReportFileName(title) {

                const date = new Date()

                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()

                const compactDate = `${day}${month}${year}`

                const cleanTitle = title
                    .replace(/[čć]/g, "c")
                    .replace("ž", "z")
                    .replace("š", "s")
                    .replace("đ", "d")
                    .split(" ")
                    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                    .join("")

                return `${cleanTitle}_${compactDate}.pdf`
            },
            openChangeIssueDoc(item) {
                this.changeIssueDocItem = item
                this.changeIssueDocFile = null
                this.changeIssueDocDialog = true
            },

            async confirmChangeIssueDoc() {
                if (!this.changeIssueDocFile) return
                try {
                    const now = new Date()
                    const m = String(now.getUTCMonth() + 1).padStart(2, '0')
                    const d = String(now.getUTCDate()).padStart(2, '0')
                    const y = now.getUTCFullYear().toString().slice(-2)
                    const h = String(now.getHours()).padStart(2, '0')
                    const min = String(now.getMinutes()).padStart(2, '0')
                    const s = String(now.getSeconds()).padStart(2, '0')
                    const ext = this.changeIssueDocFile.name.split('.').pop()
                    const fileName = `Issue_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}.${ext}`

                    const file = new File([this.changeIssueDocFile], fileName, { type: this.changeIssueDocFile.type })
                    const formData = new FormData()
                    formData.append('file', file)
                    await this.$axios.post('Upload/', formData)

                    await this.$axios.put('Issue/EditUgovor', {
                        Id: this.changeIssueDocItem.Id,
                        FileName: fileName,
                        CompanyId: Number(localStorage.getItem('CompanyId'))
                    })

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('User_message.m138'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })

                    this.changeIssueDocDialog = false
                    this.changeIssueDocFile = null
                    this.changeIssueDocItem = null
                    await this.fetchIssues()

                } catch (err) {
                    console.error(err)
                    this.$store.dispatch('NOTIF_WARNING', {
                        poruka: this.$t('User_message.m139'),
                        position: 'center',
                        icon: 'error',
                        timer: 4500
                    })
                }
            },

            openDeleteIssueDoc(item) {
                this.deleteIssueDocItem = item
                this.deleteIssueDocDialog = true
            },

            async confirmDeleteIssueDoc() {
                if (!this.deleteIssueDocItem) return
                try {
                    await this.$axios.put('Issue/DeleteUgovor', {
                        Id: this.deleteIssueDocItem.Id,
                        CompanyId: Number(localStorage.getItem('CompanyId'))
                    })

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('User_message.m141'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })

                    this.deleteIssueDocDialog = false
                    this.deleteIssueDocItem = null
                    await this.fetchIssues()

                } catch (err) {
                    console.error(err)
                    this.$store.dispatch('NOTIF_WARNING', {
                        poruka: this.$t('User_message.m142'),
                        position: 'center',
                        icon: 'error',
                        timer: 4500
                    })
                }
            },
            async previewIssueDoc(fileName) {
                if (!fileName) return
                try {
                    const res = await this.$axios.get('Upload?fileName=' + fileName, { responseType: 'arraybuffer' })
                    const isImage = /\.(png|jpg|jpeg|webp|gif)$/i.test(fileName)
                    const mimeType = isImage ? 'image/' + fileName.split('.').pop().toLowerCase() : 'application/pdf'
                    const blob = new Blob([res.data], { type: mimeType })
                    this.issueDocUrl = window.URL.createObjectURL(blob)
                    this.issueDocFileName = fileName
                    this.issueDocBlob = blob
                    this.issueDocPreview = true
                } catch (err) {
                    console.error(err)
                }
            },

            downloadIssueDoc() {
                if (!this.issueDocUrl) return
                const link = document.createElement('a')
                link.href = this.issueDocUrl
                link.setAttribute('download', this.issueDocFileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            },

            printIssueDoc() {
                this.$refs.issueDocFrame?.contentWindow?.print()
            },

            closeIssueDocPreview() {
                if (this.issueDocUrl) window.URL.revokeObjectURL(this.issueDocUrl)
                this.issueDocPreview = false
                this.issueDocUrl = null
                this.issueDocFileName = null
                this.issueDocBlob = null
            },
            openUploadDoc(item) {
                this.uploadDocItem = item
                this.uploadDocForm = { name: item.FileName ? '' : '', file: null }
                this.uploadDocDialog = true
            },

            async confirmUploadDoc() {
                if (!this.uploadDocForm.file) return
                try {
                    const now = new Date()
                    const m = String(now.getUTCMonth() + 1).padStart(2, '0')
                    const d = String(now.getUTCDate()).padStart(2, '0')
                    const y = now.getUTCFullYear().toString().slice(-2)
                    const h = String(now.getHours()).padStart(2, '0')
                    const min = String(now.getMinutes()).padStart(2, '0')
                    const s = String(now.getSeconds()).padStart(2, '0')
                    const ext = this.uploadDocForm.file.name.split('.').pop()
                    const fileName = `Issue_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}.${ext}`

                    const file = new File([this.uploadDocForm.file], fileName, { type: this.uploadDocForm.file.type })
                    const formData = new FormData()
                    formData.append('file', file)
                    await this.$axios.post('Upload/', formData)

                    await this.$axios.put('Issue/EditDokument', {
                        Id: this.uploadDocItem.Id,
                        Name: this.uploadDocForm.name || fileName,
                        FileName: fileName,
                        CompanyId: Number(localStorage.getItem('CompanyId'))
                    })

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('User_message.m138'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })

                    this.uploadDocDialog = false
                    this.uploadDocForm = { name: '', file: null }
                    this.uploadDocItem = null
                    await this.fetchIssues()

                } catch (err) {
                    console.error(err)
                    this.$store.dispatch('NOTIF_WARNING', {
                        poruka: this.$t('User_message.m139'),
                        position: 'center',
                        icon: 'error',
                        timer: 4500
                    })
                }
            },
            goBack() {
                this.$router.back();
            },
            parseMoney(value) {
                if (value === null || value === undefined || value === '') return null

                if (typeof value === 'number') return value

                return Number(
                    value
                        .replace(/\./g, '')
                        .replace(',', '.')
                )
            },
            formatMoney(v) {
                if (v === null || v === undefined || v === '') return '-'

                const n = Number(v)
                if (Number.isNaN(n)) return '-'

                return (
                    n.toLocaleString('de-DE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })
                )
            },
            openAddIssue() {
                this.isEditMode = false;
                this.formIssue = {
                    id: null,
                    description: '',
                    value: '',
                    contractor: '',
                    date: '',
                    fileName: null,
                    docName: ''
                };
                this.dialog = true;
                this.$nextTick(() => {
                    this.$refs.maintenanceDetailForm?.resetValidation()
                })
            },
            openEditIssue(issue) {
                this.isEditMode = true;
                this.formIssue = {
                    id: issue.Id,
                    description: issue.Description,
                    value: this.formatMoney(issue.Value),
                    contractor: issue.Contractor,
                    date: issue.Date,
                    fileName: null,
                    docName: '',
                    existingFileName: issue.FileName || null
                };
                this.dialog = true;
                this.$nextTick(() => {
                    this.$refs.maintenanceDetailForm?.resetValidation()
                })
            },

            openDeleteDialog(issue) {
                this.deleteIssueId = issue.Id
                this.deleteIssueDescription = issue.Description
                this.deleteDialog = true;
            },
            cancelDelete() {
                this.deleteDialog = false;
                this.deleteIssueId = null;
                this.deleteIssueDescription = '';
            },
            async confirmDelete() {
                if (!this.deleteIssueId) return;

                try {
                    const r = await this.$axios.put(
                        'Issue/Delete/' + this.deleteIssueId
                    );

                    if (r.status === 200 || r.status === 204) {
                        this.$store.dispatch('NOTIF_SUCCESS', {
                            poruka: this.$t('User_message.m144'),
                            position: 'top-end',
                            timer: 2500,
                            action: 'noreload'
                        });

                        await this.fetchIssues();
                        await this.fetchMaintenance()
                    }

                } catch (err) {
                    console.error(err);

                    this.$store.dispatch('NOTIF_WARNING', {
                        poruka: this.$t('User_message.m145'),
                        position: 'center',
                        icon: 'error',
                        timer: 4500,
                        width: '550'
                    });

                } finally {
                    this.cancelDelete();
                }
            },

            async fetchMaintenance() {
                this.loading = true
                try {

                    var data = {
                        Id: Number(this.id),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        LanguageId: Number(localStorage.getItem('LanguageId'))
                    }

                    const r = await this.$axios.post('Maintenance/Detail', data)

                    this.maintenance = r.data?.[0] ?? null

                } catch (err) {
                    console.error(this.$t('general.noData'), err)
                    this.maintenance = []
                } finally {
                    this.loading = false
                }
            },

            async fetchIssues() {
                this.loadingIssues = true
                try {

                    var data = {
                        Id: Number(this.id),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        LanguageId: Number(localStorage.getItem('LanguageId'))
                    }

                    const r = await this.$axios.post('Issue/Detail', data)

                    this.issues = r.data

                } catch (err) {
                    console.error(this.$t('general.noData'), err)
                    this.issues = []
                } finally {
                    this.loadingIssues = false
                }
            },

            async submitIssue() {
                const { valid } = await this.$refs.maintenanceDetailForm.validate()
                if (!valid) return

                try {
                    let fileName = this.formIssue.existingFileName || null

                    // Upload fajla ako je odabran
                    if (this.formIssue.fileName) {
                        const now = new Date()
                        const m = String(now.getUTCMonth() + 1).padStart(2, '0')
                        const d = String(now.getUTCDate()).padStart(2, '0')
                        const y = now.getUTCFullYear().toString().slice(-2)
                        const h = String(now.getHours()).padStart(2, '0')
                        const min = String(now.getMinutes()).padStart(2, '0')
                        const s = String(now.getSeconds()).padStart(2, '0')
                        const ext = this.formIssue.fileName.name.split('.').pop()
                        fileName = `Issue_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}.${ext}`

                        const file = new File([this.formIssue.fileName], fileName, { type: this.formIssue.fileName.type })
                        const formData = new FormData()
                        formData.append('file', file)
                        await this.$axios.post('Upload/', formData)
                    }

                    const payload = {
                        Description: this.formIssue.description,
                        Value: this.parseMoney(this.formIssue.value),
                        Contractor: this.formIssue.contractor || null,
                        Date: this.formIssue.date ? `${this.formIssue.date}T00:00:00Z` : null,
                        MaintenanceId: Number(this.id),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        FileName: fileName,
                    };

                    if (this.isEditMode) {
                        payload.Id = this.formIssue.id;
                        await this.$axios.put('Issue/Edit', payload);
                    } else {
                        await this.$axios.post('Issue/Add', payload);
                    }

                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.isEditMode ? this.$t('User_message.m147') : this.$t('User_message.m146'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    });

                    this.dialog = false;
                    await this.fetchIssues();
                    await this.fetchMaintenance()

                } catch (err) {
                    console.error(err);
                    this.$store.dispatch('NOTIF_WARNING', {
                        poruka: this.$t('User_message.m148'),
                        position: 'center',
                        icon: 'error',
                        timer: 4500
                    });
                }
            },

            formatDate(dateStr) {
                if (!dateStr) return "";
                try {
                    return format(new Date(dateStr), "dd.MM.yyyy");
                } catch {
                    return dateStr;
                }
            },
            closeDialog() {
                this.dialog = false;
                this.resetForm();

                this.$nextTick(() => {
                    this.$refs.maintenanceDetailForm?.resetValidation()
                })
            },
            resetForm() {
                this.formIssue = {
                    id: null,
                    description: '',
                    value: '',
                    contractor: ''
                };
            }
        }
    }
</script>

    <style scoped>
    .existing-file-info {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--v-theme-on-surface);
        margin-top: -8px;
        margin-bottom: 8px;
        margin-left: 36px;
    }

    .existing-file-link {
        color: #0281CA;
        font-weight: 500;
    }

    .actions-cell {
        padding: 0 8px !important;
    }
</style>